<template>
    <div>
        <a @click="$emit('action', {action: columnData.action, rowId: rowId})" class="link">{{columnData.caption}}</a>
    </div>
</template>

<script>
export default {
    props: {
        rowId: Number,
        columnData: Object,
    }
}
</script>

<style scoped>

</style>
